import {AIOptionField, matchAIOption} from "./AIMatchOption";

type LocalSelectionParams = {
  fields: readonly AIOptionField[];
  fieldName: string;
  searchText: string;
  setValue: (name: any, value: any, options?: any) => void;
  currentValue?: string | null;
};

/** Applica solo una corrispondenza locale affidabile tra le opzioni caricate. */
export function selectAIField({
  fields, fieldName, searchText, setValue, currentValue
}: LocalSelectionParams): string | null {
  const field = fields.find(item => item.name === fieldName);
  if (!field || !searchText.trim()) return null;

  const match = matchAIOption(fields, fieldName, searchText);
  if (!match) return null;

  if (match.value !== currentValue) {
    field.onChange?.(null, match.value);
    setValue(fieldName, match.value, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    });
  }

  return match.value;
}
